import * as Yup from "yup";
import { emailRegEx } from "utils/RegularExpressions";

export const defaultStepsSchema = Yup.object({
  applicantInformation: Yup.object({
    fullName: Yup.string()
      .required("Required")
      .max(250, "Must be less than 250 characters."),
    contactEmail: Yup.string()
      .required("Required")
      .matches(emailRegEx, "Please enter a valid email address"),
  }),
});
